export const DOMAIN = 'consentConfigDetails';
